export default __webpack_public_path__ + "6d66744407c89fcee0140132c6e268c7.ttf";